import { SHEET_RANGE } from '../calculate/types';
import fetchGoogleSheetData from './fetchGoogleSheetData';
import { Sheets } from './types';

/**
 * Fetches from Google API and return an object containing key/value pairs where the key is the sheet name and
 * the value is a 2D array representation of a table from a specified sheet.
 *
 * @returns {Promise<Sheets>} Object containing a key/value where the key is the sheet name, and the value is a 2D array representation of data.
 */
const fetchSheets = async (): Promise<Sheets> => {
  const [
    pricing,
    peakLoading,
    station,
    unformattedDayStrat,
    durationLoading,
    weeklyPricing,
    adMirroring
  ] = await Promise.all([
    fetchGoogleSheetData(SHEET_RANGE.PRICING),
    fetchGoogleSheetData(SHEET_RANGE.PEAK_LOADING),
    fetchGoogleSheetData(SHEET_RANGE.STATION_GRID),
    fetchGoogleSheetData(SHEET_RANGE.DAY_STRAT),
    fetchGoogleSheetData(SHEET_RANGE.DURATION_LOADINGS),
    fetchGoogleSheetData(SHEET_RANGE.WEEKLY_PRICING),
    fetchGoogleSheetData(SHEET_RANGE.AD_MIRRORING)
  ]);

  const dayStrat = removeHiddenColumns(unformattedDayStrat);

  return {
    pricing,
    peakLoading,
    station,
    dayStrat,
    durationLoading,
    weeklyPricing,
    adMirroring
  };
};

const removeHiddenColumns = (sheet: string[][]) => {
  return removeBetweenColumns(sheet, 2, 39);
};

const removeBetweenColumns = (
  sheet: string[][],
  startColumn: number,
  endColumn: number
): string[][] => {
  return sheet.map((row: string[]) =>
    row.filter(
      (_: string, columnIndex: number) =>
        columnIndex < startColumn || columnIndex >= endColumn
    )
  );
};

export default fetchSheets;
